import React from 'react';
import InputAdornment from "@material-ui/core/InputAdornment";
import SearchIcon from "@material-ui/icons/Search";
import {useSelector} from "react-redux";
import OutlinedInput from "@material-ui/core/OutlinedInput";

const Search = ({handleSearch}) => {
    const language = useSelector(state => state.store.language)
    return (
            <div
                style={{
                    backgroundColor: "white",
                    paddingTop: 10,
                    paddingBottom: 10,
                    paddingLeft:25,
                    paddingRight:25,
                    display: "flex",
                    justifyContent: "center",
                }}>
                <OutlinedInput
                    fullWidth
                    onChange={(e) => handleSearch(e)}
                    id="input-with-icon-adornment"
                    inputProps={{style: {height: 5,textAlign:language === "english"? "left":"right"}}}
                    placeholder={language === "english" ? "Search..." : "...ابحث"}
                    startAdornment={<InputAdornment position="start">
                        <SearchIcon/>
                    </InputAdornment>}
                />
            </div>
        );
};

export default Search;